import Vue from 'vue'
import App from './App.vue'
// 导入刚才创建的路由
import router from './router'

Vue.config.productionTip = false


// 路由守卫：切换页面时自动更新标题
router.afterEach((to) => {
  // 定义网站后缀（所有页面标题共用）
  const websiteSuffix = ' - 医疗行为闭环管理平台'
  // 如果当前路由有配置 title，就拼接后缀；否则使用默认标题
  if (to.meta.title) {
    document.title = to.meta.title + websiteSuffix
  } else {
    document.title = '医疗行为闭环管理平台'
  }
})

new Vue({
  router, // 挂载路由（核心：添加这一行，路由即可全局生效）
  render: h => h(App),
}).$mount('#app')
